module.exports = __webpack_public_path__ + "static/img/artitle02.c2d4dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artitle02.png
// module id = q06c
// module chunks = 0